import { render, staticRenderFns } from "./ticketViewSidebar.vue?vue&type=template&id=70eefd84"
import script from "./ticketViewSidebar.vue?vue&type=script&lang=js"
export * from "./ticketViewSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports